import qs from 'qs';
import { pick } from 'lodash';
import { History } from 'history';

export function remove(history: History, params: Array<string>) {
  const location = history.getCurrentLocation();
  const nextQuery = qs.parse(location.query);

  params.forEach((q) => delete nextQuery[q]);
  history.replace({ ...location, query: nextQuery });
}

/* Consume a query parameter.
 *
 *   import { browserHistory } from 'react-router';
 *
 *   // -> https://www.remind.com?foo=true&bar=true
 *   const params = consume(browserHistory, ['foo'])
 *
 *   // -> https://www.remind.com?bar=true
 *   console.log(params) // { foo: true }
 */
export function consume(history: History, params: Array<string>) {
  const consumed = read(history, params);
  remove(history, params);
  return consumed;
}

/* Read a query parameter.
 *
 *   import { browserHistory } from 'react-router';
 *
 *   // -> https://www.remind.com?foo=true&bar=true
 *   const params = read(browserHistory, ['foo'])
 *
 *   // -> https://www.remind.com?foo=true&bar=true
 *   console.log(params) // { foo: true }
 */
export function read(history: History, params: Array<string>) {
  const currParams = qs.parse(history.getCurrentLocation().query);
  return pick(currParams, params);
}
